import { z } from 'zod'

import { Manager } from 'app/types/park/manager'

/** Origin of creation of the Konvive. */
export const OriginKonvive = z.enum(['IMPORT', 'KONVIVES', 'MANUAL'])

/** Error type when importing the Konvive users. */
export const ErrorKonviveImport = z.enum([
    'CARD_ID',
    'EMAIL',
    'EMAIL_IN_USE',
    'MIFARE_CODE',
    'NUMERIC_TYPE',
    'STRING_TYPE',
])

/** The final consumer of a machine with an account. */
export const Konvive = z.object({
    /** The ID of the konvive. */
    id: z.number().positive(),

    client: Manager,

    /** The first name of the konvive. */
    first_name: z.string().min(1),

    /** The last name of the konvive. */
    last_name: z.string().min(1).toUpperCase(),

    /** The email of the konvive. */
    email: z.string().email(),

    phone: z.string().min(1).optional(),

    /** The private card used by the konvive. */
    card_number: z.string().min(1).optional(),
})

export type Konvive = z.infer<typeof Konvive>

export const KonviveBinding = Konvive.pick({
    id: true,
    first_name: true,
    last_name: true,
    email: true,
    card_number: true,
})

export type KonviveBinding = z.infer<typeof KonviveBinding>

export const KonviveBindingClient = Konvive.pick({
    id: true,
    client: true,
    first_name: true,
    last_name: true,
    email: true,
})

export type KonviveBindingClient = z.infer<typeof KonviveBindingClient>
